import PropTypes from 'prop-types'
import { useState } from 'react'
import { Checkbox } from '../../../common/html/checkbox'
import { Icon } from '../../../common/html/icon'
import { FilterListCheckbox } from './FilterListCheckbox'

export const FilterCheckbox = ({ option, onChange, onChangeOfChildren }) => {
  const [isShowChildren, setIsShowChildren] = useState(false)

  const onchangeCheckBoxItem = (item, isChecked) => {
    onChange(item.value, isChecked)
  }

  const onClick = (option) => () => {
    if (option.children && !!option.children.length) {
      setIsShowChildren(!isShowChildren)
    }
  }

  return (
    <div style={{ padding: '4px 0', marginTop: 4, cursor: 'pointer' }}>
      <div
        className="dFlex justifyContentBetween alignItemsCenter"
        onClick={onClick(option)}
      >
        <Checkbox
          isI18n
          isCheckOnClickText={!(option.children && !!option.children.length)}
          title={option.name}
          value={option.value}
          checked={option.isChecked}
          onChange={(value) => onchangeCheckBoxItem(option, value)}
        />
        {option.children && !!option.children.length && (
          <Icon
            className={
              isShowChildren ? 'icon-caret-bottom' : 'icon-caret-right'
            }
            style={{ fontSize: 7 }}
          />
        )}
      </div>

      {option.children && !!option.children.length && isShowChildren && (
        <div className="ml2">
          <FilterListCheckbox
            options={option.children.map((item) => ({
              name: item.name,
              value: item.value,
              isChecked: item.isChecked,
            }))}
            onChange={onChangeOfChildren}
          />
        </div>
      )}
    </div>
  )
}

FilterCheckbox.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  }),
  onChange: PropTypes.func,
  onChangeOfChildren: PropTypes.func,
}

FilterCheckbox.defaultProps = {
  option: {},
  onChange: () => {},
  onChangeOfChildren: () => {},
}
